export default "__VITE_ASSET__BH4$5jic__"